// Renders the "google-opening-hours" sections from the cached Google Places endpoint.
// Open/closed status is computed here in shop time (Europe/Vienna), because Google's
// openNow is up to a day old by the time it comes out of the CDN cache.
(function () {
  var WEEK = 7 * 1440;

  // periods: Google Places periods ({open:{day,hour,minute}, close:{...}}, day 0 = Sunday).
  // now: minutes since Sunday 00:00. Returns {open, at} (closing or next opening time) or null.
  function hoursStatus(periods, now) {
    var next = null;
    for (var i = 0; i < (periods || []).length; i++) {
      var p = periods[i];
      if (!p.open || !p.close) return { open: true, at: null }; // no close = open 24/7
      var o = p.open.day * 1440 + p.open.hour * 60 + p.open.minute;
      var c = p.close.day * 1440 + p.close.hour * 60 + p.close.minute;
      if (c <= o) c += WEEK; // closes after the week wraps (e.g. Sat 22:00 → Sun 02:00)
      for (var shift = -WEEK; shift <= 0; shift += WEEK) {
        if (now >= o + shift && now < c + shift) return { open: true, at: p.close };
      }
      var wait = (o - now + WEEK) % WEEK;
      if (!next || wait < next.wait) next = { wait: wait, at: p.open };
    }
    return next && { open: false, at: next.at, days: Math.floor((now % 1440 + next.wait) / 1440) };
  }
  globalThis.googleHoursStatus = hoursStatus;
  if (typeof document === 'undefined') return;

  function viennaNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Vienna', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { parts[x.type] = x.value; });
    var day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday);
    return day * 1440 + Number(parts.hour) * 60 + Number(parts.minute);
  }

  function render(el) {
    var lang = el.dataset.lang;
    // 24h locales get "09:00" (matches Google's list), 12h locales "9:00 AM"
    var hour = new Intl.DateTimeFormat(lang, { hour: 'numeric' }).resolvedOptions().hourCycle === 'h23' ? '2-digit' : 'numeric';
    var time = function (t) { return new Date(Date.UTC(2024, 0, 1, t.hour, t.minute)).toLocaleTimeString(lang, { hour: hour, minute: '2-digit', timeZone: 'UTC' }); };
    var weekday = function (d) { return new Date(Date.UTC(2024, 0, 7 + d)).toLocaleDateString(lang, { weekday: 'long', timeZone: 'UTC' }); };

    fetch(el.dataset.src).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); }).then(function (place) {
      var hours = place.currentOpeningHours || place.regularOpeningHours;
      var now = viennaNow();
      var today = (Math.floor(now / 1440) + 6) % 7; // weekdayDescriptions start on Monday

      var rows = hours.weekdayDescriptions.map(function (line, i) {
        var cut = line.indexOf(': ');
        var tr = document.createElement('tr');
        if (i === today) tr.className = 'gh-today';
        [line.slice(0, cut), line.slice(cut + 2)].forEach(function (text, col) {
          var td = document.createElement('td');
          td.textContent = text;
          if (col === 0 && i === today) {
            var tag = document.createElement('span');
            tag.className = 'gh-tag';
            tag.textContent = el.dataset.today;
            td.append(' ', tag);
          }
          tr.append(td);
        });
        return tr;
      });
      el.querySelector('.gh-hours tbody').replaceChildren.apply(el.querySelector('.gh-hours tbody'), rows);

      var s = hoursStatus(hours.periods, now);
      var pill = el.querySelector('.gh-pill');
      if (s && s.at) {
        var tpl = s.open ? el.dataset.openUntil : s.days === 0 ? el.dataset.opensToday : s.days === 1 ? el.dataset.opensTomorrow : el.dataset.opens;
        pill.textContent = tpl.replace('{time}', time(s.at)).replace('{day}', weekday(s.at.day));
        pill.classList.toggle('gh-pill--closed', !s.open);
        pill.hidden = false;
      }
    }).catch(function () {
      el.querySelector('.gh-hours').hidden = true;
      el.querySelector('.gh-fallback').hidden = false;
    });
  }

  document.querySelectorAll('.gh').forEach(render);
  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('.gh').forEach(render); });
})();
